module.exports = __webpack_public_path__ + "img/alchemy.f5164485.svg";